module.exports = __webpack_public_path__ + "img/ic_close_x_gray.ddf4437b.svg";